import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'form',
    'cta',
    'coordinatesField',
    'offcanvas',
    'offcanvasContainer',
    'documentContainer',
    'questionInput',
    'arrowRight',
    'arrowLeft',
  ];

  formTargetConnected (_target) {
    if (!this.coordinatesFieldTarget.value) {
      window.dispatchEvent(new Event('resetPdfReader'));
    }
  }

  showForm(event) {
    event.preventDefault();
    this.formTarget.classList.remove('d-none');

    if (this.hasCtaTarget) {
      this.ctaTarget.classList.add('d-none');
    }
  }

  hideForm(event) {
    event.preventDefault();
    this.formTarget.classList.add('d-none');
    this.questionInputTarget.value = '';

    if (this.hasCtaTarget) {
      this.ctaTarget.classList.remove('d-none');
    }
  }

  newQuestion(event) {
    this.showForm(event);
    this.coordinatesFieldTarget.value = event.detail.coordinates;
  }

  removeQuestion(event) {
    this.hideForm(event);
    this.coordinatesFieldTarget.value = '';
  }

  toggleCanvas () {
    if (this.offcanvasTarget.classList.contains('show')) {
      this.#closeCanvas();
    } else {
      this.#openCanvas();
    }
  }

  openCanvas () {
    if (this.offcanvasTarget.classList.contains('show')) {
      return;
    }

    this.#openCanvas();
  }

  #openCanvas () {
    this.arrowRightTarget.classList.remove('d-none');
    this.arrowLeftTarget.classList.add('d-none');
    this.offcanvasContainerTarget.style.width = '24rem';
    this.documentContainerTarget.style.width = 'calc(100% - 24rem)';
    this.offcanvasTarget.classList.add('show');

    window.dispatchEvent(new Event('resizeDrawCanvas'));
  }

  #closeCanvas () {
    this.offcanvasTarget.classList.remove('show');
    this.offcanvasContainerTarget.style.width = '4rem';
    this.documentContainerTarget.style.width = 'calc(100% - 4rem)';
    this.arrowRightTarget.classList.add('d-none');
    this.arrowLeftTarget.classList.remove('d-none');

    window.dispatchEvent(new Event('resizeDrawCanvas'));
  }
}
